import { render, staticRenderFns } from "./VideoCourseList.vue?vue&type=template&id=2afb9738&"
import script from "./videoCourseList.js?vue&type=script&lang=js&"
export * from "./videoCourseList.js?vue&type=script&lang=js&"
import style0 from "./videoCourseList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports